import { z } from 'zod';
import { bonusParamSchema, paramDefRowSchemaView } from '@bonusmap/api-types';
// SEMPRE array di array, mai array semplice
const bonusParametersSchema = z.array(
    z.array(bonusParamSchema)
).min(1, "Almeno un gruppo di parametri richiesto");

// questo è il tipo di input che accettiamo proveniente dalla tabella bonus campo "parameters"
const bonusParametersInputSchema = 
z.union([
        z.array(bonusParamSchema),                    // Caso semplice: [{}, {}] - tutti in AND
        z.array(z.array(bonusParamSchema))           // Caso gruppi: [[{},{}], [{},{}]] - gruppi in OR, elementi del gruppo in AND
    ])

const bonusParametersReHydratedItemSchema = bonusParamSchema.extend({
    parameter: paramDefRowSchemaView
})
const bonusParametersReHydratedSchema = z.array(
    z.array(bonusParametersReHydratedItemSchema)
);
export { bonusParametersSchema, bonusParametersInputSchema, bonusParametersReHydratedItemSchema, bonusParametersReHydratedSchema };
